import axios from "axios";

const api = axios.create({
  baseURL: "https://project.rsaisyiyahsitifatimah.com/api/v1",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  transformRequest: [
    (data) => {
      // Penting: pastikan payload dikirim sebagai JSON murni
      return JSON.stringify(data);
    },
  ],
});

export const createPenilaian = async (payload) => {
  try {
    console.log("Payload dikirim (Axios):", payload); // Debug

    const response = await api.post("/penilaian/create", payload);

    console.log("Response API (Axios):", response.data);
    return response.data;

  } catch (error) {
    console.error("Error creating penilaian:", error.response?.data || error);
    throw error;
  }
};
